/* @flow */

import * as React from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import Moment from 'react-moment';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ElectroSelectWithOther from '../../../../../../forms/components/inputs/ElectroSelectWithOther/ElectroSelectWithOther';
import ElectroMessageBarCont from '../../../../../../forms/components/inputs/ElectroMessageBarCont/ElectroMessageBarCont';
import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type { TypeDisplayErrors } from '../../../../../../forms/validation/Validator';
import styles from '../../../../ActionDrawer.module.scss';
import type Form from '../../../../../../forms/_.extend';

type TypeProps = {
  project: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveProjectForm extends React.Component<*> {
  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;
    const form: Form = this.props.form;

    const getChildData: Function = (child: string, val: string) => {
      return typeof project[child] === 'undefined' ? null : project[child][val];
    };

    const projectDetails: Array<Array> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:projects.labels.code'), project.code],
      [t('general:projects.labels.name'), project.name],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.details')}
          >
            <ActionDrawerTable data={projectDetails} />
            {project.status !== 'Ended' && (
              <ElectroMessageBarCont
                props={{
                  variant: 'warning',
                  message: t('general:projects.messages.is_active'),
                }}
              />
            )}
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.reasons.why_archive')}
          >
            <ElectroSelectWithOther
              field={form.$('archiveProjectForm.reason')}
              otherHeading={`${t('general:reasons.provide_reason')} *`}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.archive_project')} />
      </React.Fragment>
    );
  }
}
